import { NAME } from './constants';
import { router } from './router';

export const WmsDashboard = {
	name: NAME,
	router,
};
